<script lang="ts">
    import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    import { ServicesOnInvoices } from '../../modules/posApi/invoices/invoice'
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }
    export let invoiceItem: ServicesOnInvoices = undefined
    // abre um item já existente direto no modo de edição (a folha do mobile desenha a linha fechada
    // por conta própria e só usa este componente para editar). No desktop fica desligado.
    export let startEditing: boolean = false

    let step = 1
    let isNew = false
    async function editEntity() {
        step = 2
    }

    async function newEntity() {
        isNew = true
        step = 2
        invoiceItem = new ServicesOnInvoices()
    }

    async function cancelEntity() {
        invoiceItem = undefined
        step = 1
        dispatch('cancel')
    }

    async function confirmEntity() {
        if (!invoiceItem.service || !invoiceItem.user) {
            window.error('Informe todas as opções antes de confirmar.')
            return
        }

        dispatch('added', invoiceItem)
        if (isNew) invoiceItem = undefined
        step = 1
        isNew = false
    }

    onMount(() => {
        if (!invoiceItem) newEntity()
        else if (startEditing) step = 2
    })

    let lastService = null
    $: {
        if (isNew) {
            if (invoiceItem && invoiceItem.service && invoiceItem?.service != lastService) {
                lastService = invoiceItem?.service
                if (invoiceItem.service.type !== 'package') {
                    if (!invoiceItem?.quantity) invoiceItem.quantity = 1
                    invoiceItem.valueGross = invoiceItem.service?.price
                    invoiceItem.comissionPercentage = invoiceItem.service?.comissionPercentage || 0
                } else {
                    if (!invoiceItem?.quantity) invoiceItem.quantity = 0
                    invoiceItem.valueGross = 0
                    invoiceItem.comissionPercentage = 0
                }
            }
        }
    }

    function friendlyType(type: string) {
        if (type === 'service') return 'Serviço'
        if (type === 'package') return 'Pacote'
        if (type === 'product') return 'Produto'
        return type
    }

    function serviceOnClear() {
        dispatch('clear')
    }
</script>

{#if invoiceItem !== undefined}
    <div class={className}>
        {#if step === 1}
            <div class="row line h-mobile">
                <div class="col-2 nowrap">
                    {!invoiceItem?.parentServiceId ? invoiceItem.user?.userName || invoiceItem.user?.email : ''}
                </div>
                <div class="col nowrap package_{!!invoiceItem.parentServiceId}">
                    {#if !invoiceItem.parentServiceId}
                        <div class="badge badge_{invoiceItem.service.type}">
                            {friendlyType(invoiceItem.service.type)}
                        </div>
                    {:else}
                        <div class="pe-1">●</div>
                    {/if}
                    {invoiceItem.service?.name}
                </div>
                {#if invoiceItem?.service.type !== 'package'}
                    <div class="col-md-1 text-end">{window.api.utils.utils.toReal(invoiceItem.valueGross)}</div>
                    <div class="col-md-1 text-end">{invoiceItem.quantity}</div>
                    <div class="col-md-1 text-end">{window.api.utils.utils.toReal(invoiceItem.valueGross * invoiceItem.quantity) || ' -'}</div>
                {/if}
                <div class="col-md-2 text-end">
                    <Zbutton class="btn-package_{!!invoiceItem?.parentServiceId}" color="secondary" icon={faEdit} label="Editar" on:click={editEntity} />
                </div>
            </div>
            <div class="row line h-full content">
                <div class="col-6">
                    <div class="label">Item</div>
                    <div class="item nowrap">{invoiceItem.service?.name}</div>
                </div>
                <div class="col-3">
                    <div class="label">Total</div>
                    <div class="item">{window.api.utils.utils.toReal(invoiceItem.valueGross * invoiceItem.quantity) || ' -'}</div>
                </div>

                <div class="col-3 text-center">
                    <Zbutton class="mt-3 mb-2" color="secondary" icon={faEdit} label="Editar" on:click={editEntity} />
                </div>
            </div>
        {/if}
        {#if step === 2}
            <ZContainer>
                <ZContainerCol size={3} sizeM={12}>
                    {#if !invoiceItem?.parentServiceId}
                        <ZentitySelect fonte="usuario" label="Vendedor" bind:value={invoiceItem.user} />
                    {/if}
                </ZContainerCol>
                <ZContainerCol size={5} sizeM={12}>
                    <ZentitySelect
                        fonte="servico"
                        label="Item"
                        params={{ type: 'all', price: true }}
                        bind:value={invoiceItem.service}
                        on:clear={serviceOnClear}
                    />
                </ZContainerCol>
                <ZContainerCol size={1} sizeM={4}>
                    {#if invoiceItem.service && invoiceItem.service.type !== 'package'}
                        <Zinput type="number" label="Vlr Unit" bind:value={invoiceItem.valueGross} />
                    {/if}
                </ZContainerCol>
                <ZContainerCol size={1} sizeM={4}>
                    {#if invoiceItem.service && invoiceItem.service.type !== 'package'}
                        <Zinput type="number" label="Qtde" bind:value={invoiceItem.quantity} />
                    {/if}
                </ZContainerCol>
                <ZContainerCol size={1} sizeM={4}>
                    {#if invoiceItem.service && invoiceItem.service.type !== 'package'}
                        <Zinput type="number" label="Total" value={invoiceItem.valueGross * invoiceItem.quantity} disabled={true} />
                    {/if}</ZContainerCol
                >
                <ZContainerCol size={1} sizeM={12} flex={true}>
                    <Zbutton grow={true} color="red" class="me-2" icon={faTrashAlt} on:click={cancelEntity} />
                    <Zbutton grow={true} color="primary" icon={faCheck} on:click={confirmEntity} />
                </ZContainerCol>
            </ZContainer>
        {/if}
    </div>
{/if}

<style>
    .package_true {
        padding-left: 60px;
        display: flex;
        align-items: center;
    }
    .btn-package_true {
        opacity: 0.6;
    }
    .package_false {
        display: flex;
        align-items: center;
    }

    .content .label {
        color: #328866;
        font-weight: 300;
    }
    .content .item {
        margin-top: -3px;
        margin-bottom: 3px;
    }
    .btns {
        border: 0px solid red;
    }
    @media (min-width: 1200px) {
        .width-user {
            max-width: 250px;
        }
        .width-vlr {
            max-width: 160px;
        }

        .width-qtde {
            max-width: 115px;
        }

        .width-total {
            max-width: 125px;
        }
    }

    @media (max-width: 1199px) {
        .space-bottom {
            margin-bottom: 8px;
        }
    }

    @media (max-width: 900px) {
        .btns {
            margin-top: 12px;
            max-width: unset;
        }
        .space-bottom {
            margin-bottom: unset;
        }
    }
</style>
